import { useMemo } from 'react';

import {
  GetStaticPageRoutesQuery,
  IGetStaticPageRoutesQuery,
  IStaticPageRoute
} from 'remote/queries/static-page';
import { useLazySanityQuery } from 'state/graphql';

export const useStaticPageRoutes = () => {
  const [loadRoutes, { data, error, loading, refetch }] = useLazySanityQuery<
    IGetStaticPageRoutesQuery
  >(GetStaticPageRoutesQuery, {}, { isV2: true });

  const routes = useMemo<IStaticPageRoute[]>(
    () => (data && data.allStaticPage ? data.allStaticPage : []),
    [data]
  );

  return { loadRoutes, error, loading, refetch, routes };
};
